
export interface ISerologyTransactionDetails {
    orderId: number,
    donorCenter: string,
    donorAlias: string,
    recipientCenter: string,
    recipientAlias: string,
    swapNumber: number,
    clusterNumber: number,
    position: number,
    requestedDate: string,
    completed: string
}
